<template>
  <div class="col-12 col-xl-4 key-f-wrap">
    <div class="key-f-inner">
      <div class="key-f-content">
        <h2 class="content-section-title">{{data.name}}</h2>
        <p>{{data.desc}}</p>
        <router-link class="btn btn-primary btn-sq btn-flat" :to="data.to">Take A Look</router-link>
      </div>
      <div class="key-f-img">
        <b-img :src="getImgSrc" :alt="data.name" fluid />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "idx"],
  computed: {
    getImgSrc() {
      return require(`@/assets/images/home/new_p_${this.idx + 1}.png`);
    },
  },
};
</script>

<style lang="scss">
.key-f {
  &-wrap {
    padding: 50px 25px !important;
    background-image: url("~@/assets/images/home/new_p_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
  }
  &-inner {
    position: relative;
    max-width: 500px;
    margin: 0 auto;
  }
  &-img {
    text-align: right;
    img {
      max-width: 100%;
      @media (min-width: 996px) {
        max-width: 300px;
      }
      @media (min-width: 1200px) {
        max-width: 320px;
      }
      @media (min-width: 1400px) {
        max-width: 350px;
      }
    }
  }
  &-content{
    position: absolute;
    h2 {
      margin-bottom: 5px;
      text-align: left;
      font-size: 36px !important;
    }
    p {
      font-size: 18px;
    }
  }
}
</style>